import Vue from 'vue'
import VueMq from 'vue-mq'
import { VLazyImagePlugin } from "v-lazy-image"
import Home from '../pages/Home'
import Vuex from "vuex";
import i18nVuex from 'i18n-vuex'
import english from '../locale/en'

Vue.use(Vuex)
Vue.use(VLazyImagePlugin)
Vue.use(VueMq, {
  breakpoints: {
    sm: 640,
    md: 960,
    lg: Infinity,
  }
})
const store = new Vuex.Store({
  modules: {
    i18n: i18nVuex.store
  }
})
Vue.use(i18nVuex.plugin, store)
Vue.i18n.add('en', english)
Vue.i18n.set('en')

const routes = {
  '/': Home
}

new Vue({
  el: 'pages',
  data: {
    currentRoute: window.location.pathname
  },
  computed: {
    ViewComponent () {
      if(routes[this.currentRoute]) {
        return routes[this.currentRoute]
      } else {
        window.location.href = "/not-found"
      }
    }
  },
  render (h) { return h(this.ViewComponent) },
  store
})